export const APP_ID = "oapapp";
export const DEFAULT_NOTIFICATION_TIMEOUT = 10000;
export const LOGIN_PAGE = "/login";
export const TOKEN_PAGE = "/token";
export const FORBIDDEN_PAGE = "/403";
export const GRAPHQL_API_URL = "/api/graphql";
export const DEFAULT_PAGE_SIZE = 30;
export const MIN_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

export const DISPLAY_CALENDAR_DAY_TITLE = "MMMM yyyy";
export const DISPLAY_CALENDAR_MONTH_TITLE = "yyyy";
